module.exports = ".categories-container {\n  min-height: 400px;\n  padding-top: 20px; }\n  .categories-container mat-checkbox {\n    display: block;\n    margin-top: 10px; }\n  .categories-container mat-checkbox:first-child {\n      margin-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/products/product-suggested-in-categories-form/product-suggested-in-categories-form.component.scss
// module id = ./libs/atenea-cms-brand/src/products/product-suggested-in-categories-form/product-suggested-in-categories-form.component.scss
// module chunks = main